<div class="admin page">
    <!-- <app-loading-spinner></app-loading-spinner>  -->
    <mat-sidenav-container autosize>
        <mat-sidenav fxShow="true" fxHide.lt-md="true" [style.width.px]="widthSideBar" id="sidenav" #sidenav mode="side"
            opened="true" class="side">
            <ng-container>
                <app-side-nav *ngIf="loaded" [isExpaned]="isExpaned" [user]="user"
                    (open)="openOnglet($event)"></app-side-nav>
                <div class="stack">
                    <mat-nav-list>

                        <mat-list>

                            <mat-list-item class="wit" [style.width.px]="grey" [routerLinkActive]="['active']"
                                style="background-color:#f2f2f2;" (click)="toggle();">
                                <mat-icon *ngIf="!isExpaned" mat-list-icon
                                    [ngClass]="{'rotated': isExpaned}">arrow_forward_ios
                                </mat-icon>
                                <mat-icon *ngIf="isExpaned" mat-list-icon
                                    [ngClass]="{'rotated': isExpaned}">arrow_back_ios
                                </mat-icon><span *ngIf="isExpaned">Réduire le menu</span>
                            </mat-list-item>
                        </mat-list>
                    </mat-nav-list>
                </div>
            </ng-container>
        </mat-sidenav>
        <mat-sidenav-content>
            <div class="full-page">
                <app-header></app-header>
                <div class="container-fluid mt-2" style="position: relative;">
                    <div class="burger" *ngIf="tables.length > 1">
                        <button mat-button [matMenuTriggerFor]="menu"
                            #menuTrigger="matMenuTrigger"><mat-icon>menu</mat-icon></button>

                        <mat-menu #menu="matMenu" cdkDropList [cdkDropListData]="tables"
                            (cdkDropListDropped)="onDrop($event)">
                            <div mat-menu-item class="close-all-tabs" (click)="closeAllTabs()">FERMER TOUS LES ONGLETS
                            </div>
                            <div mat-menu-item *ngFor="let tab of tables; let index = index" cdkDrag [cdkDragData]="tab"
                                (mouseenter)="onHover(index)" class="d-flex justify-content-between align-items-center"
                                (click)="selectTab({index})">
                                <div>
                                    <mat-icon>drag_indicator</mat-icon><span
                                        style="margin-right: 15px;">{{tab.title}}</span>
                                </div>
                                <div><mat-icon class="m-0" *ngIf="tab.title !=='Accueil'"
                                        (click)="$event.stopPropagation(); removeTab(index)"> close</mat-icon>
                                </div>
                            </div>

                        </mat-menu>

                    </div>
                    <mat-tab-group [(selectedIndex)]="selected" (selectedTabChange)="selectTab($event)"
                        animationDuration="500ms" *ngIf="renderFlag">
                        <mat-tab *ngFor="let tab of tables; let index = index; trackBy: trackByFn" [label]="tab.title">
                            <ng-template mat-tab-label>
                                {{tab.title}}
                                <mat-icon *ngIf="tab.title !=='Accueil'" (click)="removeTab(index)"> close</mat-icon>
                            </ng-template>

                            <ng-template matTabContent>
                                <app-tab-content *ngIf="!tab.isExtranet" [tab]="tab"
                                    style="display: block; height: inherit;"></app-tab-content>
                                <div *ngIf="tab.isExtranet" style="display: block; height: inherit;">
                                    <app-tab-extranet></app-tab-extranet>
                                </div>
                            </ng-template>
                        </mat-tab>
                    </mat-tab-group>
                </div>

            </div>
        </mat-sidenav-content>

    </mat-sidenav-container>
</div>